import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Field, formValueSelector, reduxForm } from 'redux-form';
import Dialog from 'material-ui/Dialog';
import { isValidNameWithSpace, renderTextArea, renderTextField } from '../../../../../components/reduxFields';
import { CancelButton, SubmitButtonModal, SubmitButtonModalDisabled } from '../../../../../components/buttons';
import { getDiagnosisCodeById, saveDiagnosisCodes } from '../actions/DiagnosisCodeActions';
import validate from '../validate';
import { checkFieldExistence, clearFieldErrorArray } from '../../../../../modules/AppConfig/actions';
import { MODULE } from '../constants/ApiConstants';
import { displayCustomError } from '../../../../../../src/actions/utilAction';
import SmallLoader from '../../../../../img/small-loader.gif';

class DiagnosisCodeModal extends Component {

  constructor(props) {
    super(props);
    this.state = {
      open: true,
      diagnosisCodeId: props.diagnosisCodeId,
      IsBillable: null,
    };
  }

  handleOpen = () => {
    this.setState({ open: true });
  };
  componentWillReceiveProps() {

    let self = this;
    document.onkeydown = function(evt) {
      evt = evt || window.event;
      if (evt.keyCode === 27) {
        self.handleClose();
      }
    };

  }
  handleClose = () => {
    if (this.state.open) {
      this.props.clearFieldErrorArray();
      this.setState({ open: false });
      this.props.closeDialog();
    }
  };

  checkFieldDataExistence = (input, value, labelName) => {
    if (value.length > 0) {
      // console.log('labelName...........',labelName)
      let postData = {
        'labelName': labelName,
        'tableName': `${MODULE}_${input.target.name}`.toUpperCase(),
        'value': value,
        'colmnName': input.target.name.toUpperCase(),
        'id': (this.props.initialValues && this.props.initialValues.ServiceCodeID) ? this.props.initialValues.ServiceCodeID : 0,
      };
      this.props.checkFieldExistence(postData);
    }
  };
  componentWillMount() {
    if (this.props.diagnosisCodeId) {
      this.props.getDiagnosisCodeById(this.props.diagnosisCodeId);
    }
  }
  onSubmitHandler(formData) {
    if ((this.props.fieldError && this.props.fieldError.length) || (this.props.fieldErrorLoading)) { // Avoid Submit if field error checking
      return null;
    }
    formData.value = undefined;
    formData.code = formData.code.trim();
    formData.description = formData.description ? formData.description.trim() : '';
    this.props.clearFieldErrorArray();
    this.props.saveDiagnosisCodes(formData);
    this.setState({ open: false });
    this.props.closeDialog();
  }
  renderLoading() {
    return (
      <div>
        {this.props.loading ?
          <div className="full_loader top0">
            <div className="small-loader">
              <img src={SmallLoader} alt="" />
            </div>
          </div>
          : null}
      </div>
    );
  }

  render() {
    const { handleSubmit } = this.props;
    let submitButton = this.props.loading ?
      <SubmitButtonModalDisabled label="Loading"/> :
      <SubmitButtonModal label="Save" onSubmit={handleSubmit(this.onSubmitHandler.bind(this))}/>;
    const actions = [
      <CancelButton className="mr-15" onTouchTap={this.handleClose}/>,
      submitButton,
    ];
    return (
      <Dialog className="custom_modal"
        title={this.props.diagnosisCodeId ? 'Edit Diagnosis Code' : 'Add Diagnosis Code'}
        modal={false}
        open={this.state.open}
        actions={actions}
        autoScrollBodyContent={true}>

        <div className="row">
          <div className="col-sm-12">
            <form className="readmin-form custom_form" onSubmit={handleSubmit(this.onSubmitHandler.bind(this))}>
              <div className="row">
                <div className="col-sm-12  require">
                  {this.props.diagnosisCodeId ?
                    <Field
                      autoFocus={true}
                      name="code"
                      type="text"
                      onBlur={(input, value) => this.checkFieldDataExistence(input, value, 'code')}
                      customError={displayCustomError('CODE', this.props.fieldError)}
                      maxLength="7"
                      label="Diagnosis Code"
                      disabled={true}
                      normalize = {isValidNameWithSpace}
                      component={renderTextField} />
                    :
                    <Field
                      autoFocus={true}
                      name="code"
                      type="text"
                      onBlur={(input, value) => this.checkFieldDataExistence(input, value, 'code')}
                      customError={(this.props.fieldError && this.props.fieldError.length && this.props.fieldError.some((err) => {
                        return (err.statusCode === 409 && err.data.toUpperCase() === 'CODE');
                      })) ? <p>{this.props.fieldError.map((err) => {
                          if (err.statusCode === 409 && err.data.toUpperCase() === 'CODE') {
                          }
                          return `${err.message}`;
                        })}</p> : undefined}
                      maxLength="8"// according to icd-10 standard
                      label="Diagnosis Code"
                      normalize = {isValidNameWithSpace}
                      component={renderTextField} />
                  }
                </div>
                <div className="col-sm-12 col-md-12 require">
                  <Field
                    name="description"
                    type="text"
                    maxLength="1000"
                    label="Description"
                    // normalize = {isValidNameWithSpace}
                    component={renderTextArea} />
                  <small className="blackfont font12">{this.props.description ? 1000 - this.props.description.length : 1000} Characters Remaining </small>
                </div>
              </div>
              {/* <div className="row">
                <div className="col-sm-12 pt20 btn_rt">
                  <FlatButton className="grey_btn"
                    label="Cancel"
                    onTouchTap={this.handleClose}
                  />
                  <FlatButton className="blue_btn"
                    label="Submit"
                    primary={true}
                    type='submit'
                  />
                </div>
              </div> */}
            </form>
          </div>
        </div>
      </Dialog>
    );
  }
}
const selector = formValueSelector('DiagnosisCodeModalForm');
function mapStateToProps(state, ownProps) {
  let initialValueData = null;
  if (ownProps.diagnosisCodeId && state.diagnosisCode.getDiagnosisCodeById && state.diagnosisCode.getDiagnosisCodeById.data) {
    initialValueData = state.diagnosisCode.getDiagnosisCodeById.data;
  }
  return {
    description: selector(state, 'description'),
    loading: state.diagnosisCode.loading,
    fieldError: state.appConfig.fieldError,
    fieldErrorLoading: state.appConfig.fieldErrorLoading,
    initialValues: initialValueData,
  };
}

DiagnosisCodeModal = reduxForm({
  form: 'DiagnosisCodeModalForm',
  validate,
  enableReinitialize: true,
})(DiagnosisCodeModal);

export default connect(mapStateToProps, { checkFieldExistence, clearFieldErrorArray, saveDiagnosisCodes, getDiagnosisCodeById })(DiagnosisCodeModal);



// WEBPACK FOOTER //
// ./src/modules/Masters/components/diagnosisCode/components/DiagnosisCode_Modal.js